<div class="pagination">
  <div class="pagination__prev">
    <button
      mat-icon-button
      (click)="isRearSide ? next() : prev()"
      *ngIf="isLockerFullWidth === false"
    >
      <span class="material-icons"> chevron_left </span>
    </button>
  </div>
  <div
    #layoutContainer
    class="array-layout"
    [ngClass]="{ 'full-width': isLockerFullWidth, 'rear-side': isRearSide }"
  >
    <div
      #locker
      class="locker"
      [ngStyle]="{ width: isLockerFullWidth ? lockerWidthPx + 'px' : '100%' }"
    >
      <div
        *ngFor="let space of spaces"
        class="locker__space"
        [ngStyle]="{
          left:
            (space.hardwareInfo.coordinates.x
              ? (space.hardwareInfo.coordinates.x / space.hardwareInfo.width) * SPACE_WIDTH_PX
              : 0) + 'px',
          top: space.hardwareInfo.coordinates.y * this.scale + 'px',
          width: SPACE_WIDTH_PX + 'px',
          height: space.hardwareInfo.height * this.scale + 'px'
        }"
      >
        <frodo-locker-space
          [space]="space"
          [isSelected]="spacesSelected.includes(space.id)"
          (clickSpace)="handleSpaceClick($event)"
        >
        </frodo-locker-space>
      </div>
    </div>
  </div>
  <div class="pagination__next">
    <button
      mat-icon-button
      (click)="isRearSide ? prev() : next()"
      *ngIf="isLockerFullWidth === false"
    >
      <span class="material-icons"> chevron_right </span>
    </button>
  </div>
</div>
